<template>
    <div>
        <inc-bid-zoom
            v-if      = "zoom"
            :bid      = "bid"
            :data     = "data"
            :status   = "step.status"
            :form     = "form"
            @close    = "zoom = false"
            :readonly = "true"
            style="position: absolute; top: 0; width: 100%"
        />

        <div
            v-if="bid && unit && currentInStep"
            class="abstract-container lm-border pa-3 pr-1 h-100"
            :style="collective ? 'max-height: 512px;' : ''"
        >
            <div class="v-flex w-100">
                <div>
                    <div class="abstract-prev-step">2a</div>
                    <div class="abstract-prev-bar"></div>
                </div>
                <div class="abstract-panel">
                    <inc-abstract-company
                        :manufacturer   = "bid.manufacturer"
                        :execution-date = "currentInStep.executionDate"
                        :deliverytime   = "bid.deliverytime"
                        class="mb-0"
                        :background     = "collective ? 'field-collective' : 'ro-background'"
                    />

                    <div class="abstract-group mb-0" v-if="bid.number">
                        <inc-calculation-sum
                            class="mb-1"
                            :calculations = "bidUnitData"
                            :navigation   = "true"
                            :collective   = "collective"
                            @navigate     = "onZoom"
                        />
                    </div>

                    <div class="abstract-group mb-0" v-if="bid.number && collective">
                        <inc-calculation-sum
                            class="mb-0"
                            :calculations = "currentBidUnitData"
                            :navigation   = "true"
                            :collective   = "false"
                            @navigate     = "onZoom"
                        />
                    </div>

                    <div class="abstract-group mb-0" >
                        <f-title :title="$t('repair.bid.label.measure')" />
                        <div
                            class="abstract-info ro-background"
                            style="min-height: 70px"
                        >
                            {{ bid.calculations[0].notice }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import moment             from "moment";
import IncCalculationSum  from "@/modules/inc/steps/components/repair/private/IncCalculationSum.vue";
import IncAbstractCompany from "@/modules/inc/steps/components/common/IncAbstractCompany.vue";
import FTitle             from "@/modules/core/components/utils/FTitle.vue";
import IncBidZoom         from "@/modules/inc/steps/components/repair/private/IncBidZoom.vue";

export default {
    name: "IncBidAbstract",
    props: {
        incident: {

        },

        data: {

        },

        unit: {

        },

        form: {

        },

        collective: {

        }
    },

    data: () => ({
        zoom: false,
    }),

    components: {
        IncBidZoom,
        FTitle,
        IncAbstractCompany,
        IncCalculationSum,
    },

    computed: {
        step() {
            const id = this.data.sequence.replace("b", "a");
            return this.incident.data.find(step => step.sequence === id);
        },

        bid() {
            let bids = this.step.bids;
            if (!this.step.collective) {
                const unit = this.$store.getters.site;
                const entry = this.step.collection.find(e => {
                    return e.unit.id === unit.id
                });

                if (entry) {
                    bids = entry.bids;
                }
            }

            if (!bids || bids.length === 0) {
                return null;
            }

            return bids[0]; //.find(bid => bid.favorite === true);
        },

        currentBidUnitData () {
            return [ this.bid.calculations.find (data => data.unit.id === this.unit.id) ];
        },

        bidUnitData () {
            if (this.collective) {
                return this.bid.calculations;
            }

            return this.currentBidUnitData;
        },

        currentInStep () {
            if (!this.unit) {
                return null;
            }

            return this.step.collection.find (s => s.unit.id === this.unit.id);
        }
    },

    methods: {
        format (value) {
            if (value === null) {
                return "---";
            }
            return moment (value).format('DD.MM.YYYY');
        },

        onZoom () {
            this.zoom = true;
        }
    }
}
</script>

<style src="../../../../../assets/css/abstract.css">

</style>